
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tips_to_reduce_costs",
      function () {
        return require("private-next-pages/tips_to_reduce_costs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tips_to_reduce_costs"])
      });
    }
  